<template>
  <div class="uploadImg">
    <div class="cover">
      <el-upload
        class="avatar-uploader"
        :action="`${process.env.VUE_APP_SCTCC_CASTLE_URL}/aliyun/oss/OSSController/uploadFile`"
        :show-file-list="false"
        :headers="headers"
        :data="requestParams"
        :accept="acceptType"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload"
        v-loading="loading"
        :on-progress="uploadprogress"
        :disabled="apiParams.disabled || false"
      >
        <img v-if="params && params[apiParams.imgPath]" :src="imageUrl" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </div>
  </div>
</template>

<script>
import upload from "@/assets/img/loading/upload.jpg";
export default {
  props: {
    params: {}, //参数
    apiParams: {}, //请求参数
  },
  data() {
    return {
      loading: false, //正在上传loading
      headers: {
        token: sessionStorage.getItem("token")
      },
      acceptType: "",
      imageUrl: upload, //单个图片
      fileList: [], //图片列表
      fileIds: [] //图片列表id
      // params:{
      //   coverPath:'', 必传
      //   cover:'' 必传
      // },
      // apiParams:{
      //   params:{  //文件上传所需要的参数
      //     catalog: '',
      //     loginKey: '',
      //   },
      //   size: 5, //文件大小
      //   type: "pdf", //类型 pdf ysb(压缩包包含rar和zip) zip rar
      //   imgPath: 'coverPath', //文件路径字段
      //   fileId: 'cover', //文件id字段
      // }
    };
  },
  computed:{
    //请求参数
    requestParams(){
      let params = Object.assign({}, this.apiParams.params, {
        loginKey: sessionStorage.getItem('loginKey')
      })
      return params
    }
  },
  mounted() {
    this.getType();
  },
  methods: {

    /*上传窗口文件类型**/
    getType() {
      let needType = this.apiParams.type; //上传文件后缀名
      let acceptType = "";
     if (needType === "pdf") {
        acceptType = "application/pdf";
      } else if (needType === "ysb") {
        acceptType = "application/zip;application/rar,rar";
      } else if (needType === "zip") {
        acceptType = "application/zip";
      } else if (needType === "rar") {
        acceptType = "application/rar,rar";
      } else if (needType === "tupian") {
        acceptType = "image/*";
      }else if(needType === "ysb|pdf"){
        acceptType = "application/pdf;application/zip;application/rar,rar";
      }else if(needType === "tupian|pdf"){
        acceptType = "application/pdf;image/*";
      }else if(needType === "wendang"){
        acceptType = '';
      }else if(needType === "wendang|ysb"){
        acceptType = '';
      }
      this.acceptType = acceptType;
    },
    /** 上传成功(单图)*/
    handleAvatarSuccess(file) {
      this.loading = false;
      if (file.error.err_code !== 0) {
        this.$message({
          message: "上传失败！",
          type: "error"
        });
        return;
      }
      // this.imageUrl = file.obj.filePath;
      // this.params[this.apiParams.imgPath] = file.obj.filePath;
      // this.params[this.apiParams.fileId] = file.obj.fileId;
      this.$set(this.params,this.apiParams.imgPath,file.obj.filePath);
      this.$set(this.params,this.apiParams.fileId,file.obj.fileId);
       this.$message({
        message: `上传成功！`,
        type: "success"
      });
    },


    /**
     * 删除图片处理-详情图
     */
    handleAbstractRemove(file, fileList) {
      let temp = this.common.clone(this.fileIds);
      for (let i = 0; i < temp.length; i++) {
        if (
          (file.id && temp[i] === file.id) ||
          (file.response && temp[i] === file.response.obj.fileId)
        ) {
          temp.splice(i, 1);
          break;
        }
      }
      this.fileIds = temp;
      this.params[this.apiParams.fileId] = this.fileIds.join(",");
      console.log(this.params[this.apiParams.fileId]);
    },

    /** 上传之前*/
    beforeAvatarUpload(file) {
      const needType = this.apiParams.type; //上传文件类型
      var filename= file.name;
      var index1=filename.lastIndexOf(".");
      var index2=filename.length;
      filename =filename.substring(index1,index2);
      let size = this.apiParams.size; //文件大小是否合格
      let isTrue = false; //文件类型是否合格

      let pdfReg = /\.pdf/i;
      let ysbReg = /\.(rar)|(zip)/i;
      let tuReg = /(\.gif|\.jpeg|\.png|\.jpg|\.bmp)/i;
      let ysbpdf = /\.(rar)|(zip)|(pdf)/i;
      let tupianpdf = /\.pdf|\.gif|\.jpeg|\.png|\.jpg|\.bmp/i;
      console.log(filename)
      let wendang = /\.pdf|\.PPT|\.PPTX|\.doc|\.DOCX/i;
      let wendangysb = /\.pdf|\.PPT|\.PPTX|\.doc|\.DOCX|\.rar|.zip/i;
      if (needType === "pdf" && pdfReg.test(filename)) {
        isTrue = true;
      } else if (needType === "ysb" && ysbReg.test(filename)) {
        isTrue = true;
      } else if (needType === "tupian" && tuReg.test(filename)) {
        isTrue = true;
      }else if(needType === "ysb|pdf" && ysbpdf.test(filename)){
         isTrue = true;
      }else if(needType === "tupian|pdf" && tupianpdf.test(filename)){
         isTrue = true;
      }else if(needType === "wendang" && wendang.test(filename)){
         isTrue = true;
      }else if(needType === "wendang|ysb" && wendang.test(wendangysb)){
        isTrue = true;
      } else {
        isTrue = false;
      }

      const isLt2M = file.size / 1024 / 1024 < size;
      const _text = size < 1 ? size * 1024 + "KB" : size + "MB";
      if (!isLt2M) {
        this.$message.error(`上传文件大小不能超过 ${_text}!`);
      }

      let errMsg = "";
      if (needType === "ysb") {
        errMsg = "上传文件只能是rar或zip格式!";
      } else if (needType === "tupian") {
        errMsg = "上传文件只能是图片格式!";
      } else if (needType === "ysb|pdf") {
        errMsg = "上传文件只能是rar、zip、pdf!";
      }else if(needType === "tupian|pdf"){
        errMsg = "上传文件只能是图片格式或pdf!";
      }else if(needType === "wendang"){
        errMsg = "上传文件只能是PDF、PPT、PPTX、DOC、DOCX";
      } else if(needType === "wendang|ysb"){
        errMsg = "上传文件只能是PDF、PPT、PPTX、DOC、DOCX、rar、zip、pdf!";
      } else {
        errMsg = `上传文件只能是 ${needType}格式!`;
      }

      if (!isTrue) {
        this.$message.error(errMsg);
      }

      return isTrue && isLt2M;
    },
    /*正在上传时 可设置进度条**/

    uploadprogress() {
      this.loading = true;
    }
  }
};
</script>

<style lang="scss">
.uploadImg {
  .cover,
  .picture {
    .suggest {
      margin-top: 14px;
      color: #aaa;
    }
  }

  .avatar-uploader {
    width: 80px;
    height: 80px;
    border-radius: 6px;
  }
  .avatar-uploader .el-upload {
    background-color: #f8f8f9;
  }
  .avatar-uploader .el-upload,
  .avatar-uploader-picture-card .el-upload {
    border: 1px solid #ecf0f5;
    width: 80px;
    height: 80px;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover,
  .avatar-uploader-picture-card .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    display: flex;
    width: 100%;
    height: 100%;
    font-size: 28px;
    color: #ced2e0;
    justify-content: center;
    align-items: center;
  }
  .avatar {
    width: 100%;
    height: 100%;
    display: block;
  }

  .avatar-uploader-picture-card {
    border-radius: 6px;
    display: flex;
  }
  .avatar-uploader-picture-card .el-upload {
    background-color: #f8f8f9;
  }
  .el-upload-list .el-upload-list__item {
    width: 80px;
    height: 80px;
  }
  .el-upload-list li label {
    display: none !important;
  }
  .el-upload-list li .el-icon-close-tip {
    display: none !important;
  }
}
</style>
